import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const slbApi = axios.create({
  baseURL: `${BACKEND_URL}/api/station-logbook`,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - add auth token
slbApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - verify module header
slbApi.interceptors.response.use(
  (response) => {
    const moduleHeader = response.headers?.["x-module"];
    if (moduleHeader && moduleHeader !== "station-logbook") {
      console.error(
        "WRONG MODULE RESPONSE! Expected station-logbook but got:",
        moduleHeader,
        "URL:",
        response.config?.url
      );
    }
    return response;
  },
  (error) => {
    // Handle 401 - redirect to login (basename-aware)
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // Use basename-aware redirect for production
      const hostname = window.location.hostname;
      const loginPath = hostname.includes('stationlogbook.com') ? '/station-logbook/login' : '/login';
      window.location.href = loginPath;
    }
    return Promise.reject(error);
  }
);

export default slbApi;
